export const NETWORK_OFFLINE = 'NETWORK_OFFLINE';
export const NETWORK_ONLINE = 'NETWORK_ONLINE';
